import { useEffect } from 'react';
import { Skeleton } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { getNotification } from '../../actions/notification';
import NotificationTabs from "./NotificationTabs";
import { useLocation } from 'react-router';
import { getItem } from '../../utils/DataProtection';

export default connect(({ notification }) => ({ notification }), { getNotification })(props => {

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const nodeid = params.get('nodeid');
  const dispatch = useDispatch();

  const nodeidLS = getItem('notification-nodeid');
  const activeNodeId = nodeid !== null ? nodeid : nodeidLS;
  const loadedNodeId = props?.notification?.notification?.nodeid;

  useEffect(() => {
    if (!activeNodeId) return;
    props.getNotification({ nodeid: activeNodeId }, 'GETSINGLENOTIFICATION');
  }, [activeNodeId, props.getNotification]);

  useEffect(() => {
    return () => {
      if(!window.location.href.includes("nodeid") && !window.location.pathname.includes("create-report") && !window.location.pathname.includes("edit-report") && !window.location.pathname.includes("notification-details") && !window.location.pathname.includes("edit-notification")){
      dispatch({ type: 'CLEARNOTIFICATION', payload: {} });
      }
    }
  }, [])

  const isLoading = !loadedNodeId || (activeNodeId && loadedNodeId !== activeNodeId);

  return (
    <>
      {isLoading ? (
        <div className="bxShadow" style={{ padding: "24px", backgroundColor: "#fff" }}>
          <Skeleton variant="rectangular" height={140} style={{ marginTop: 12, borderRadius: 8 }} />
          <Skeleton variant="rectangular" height={320} style={{ marginTop: 30, borderRadius: 8 }} />
        </div>
      ) : (
        <NotificationTabs />
      )}
    </>
  );
})
